import { Language } from 'interfaces/Language'
import HarryImage from 'assets/pro-plan/harry.webp'
import { ParsedLocale } from 'lib/constants/localization'
import { TFunction } from 'i18next'
import { StripeSubscription } from 'interfaces/StripeSubscription'
import { Environment, getEnvironment } from 'lib/config'

export function returnPlusPlanContactByContentLanguage(t: TFunction<'plusPlan'>) {
    const details = {
        subtitle: t('plusPlan/contactPersonDetailSubtitle'),
        headingText: t('plusPlan/contactPersonDetailHeadingText'),
        image: HarryImage,
        name: t('plusPlan/contactPersonName'),
        email: t('plusPlan/contactPersonEmail'),
        buttonLink: `mailto:${t('plusPlan/contactPersonEmail')}`,
        buttonText: t('plusPlan/contactPersonDetailButtonText'),
        employeeTitle: t('plusPlan/contactPersonDetailEmployeeTitle'),
    }

    return details
}

export const getProPlanStripeUrl = ({ contentLanguageCode }: ParsedLocale) => {
    const environment = getEnvironment()
    if (environment === Environment.Dev || environment === Environment.Local) {
        return 'https://buy.stripe.com/test_14k3dkcpB7MmaGIbII'
    }
    switch (contentLanguageCode) {
        case Language.German:
            return 'https://buy.stripe.com/14kg2t3ay86XdKo7sw'
        case Language.Italian:
            return 'https://buy.stripe.com/9AQ9E57qObj9dKoeV0'
        case Language.Polish:
            return 'https://buy.stripe.com/28o9E5h1o4UL7m028f'
        case Language.French:
            return 'https://buy.stripe.com/4gwaI95iGcnd21G4gl'
        default:
            return null
    }
}

export const getProPlanStripePriceAmount = ({ contentLanguageCode }: ParsedLocale) => {
    switch (contentLanguageCode) {
        case Language.German:
            return 3599
        case Language.Italian:
            return 2499
        case Language.Polish:
            return 4599
        case Language.French:
            return 3599
        default:
            return null
    }
}

export const getStripeLatamAmStripeUrl = (type: 'yearly' | 'monthly' | 'weekly') => {
    switch (type) {
        case 'yearly':
            return 'https://buy.stripe.com/fZe17z5iG0EvaycdQR'
        case 'monthly':
            return 'https://buy.stripe.com/3cs7vX4eCevldKo5km'
        case 'weekly':
            return 'https://buy.stripe.com/eVa8A1fXkaf549O003'
        default:
            return null
    }
}

const PLUS_PLAN_STORAGE_KEY = 'SUBSCRIPTION_PLUS_PLAN'

export function getPlusPlanStoredSubscription(): StripeSubscription | null {
    const subscription = localStorage.getItem(PLUS_PLAN_STORAGE_KEY)
    if (!subscription) return null

    return JSON.parse(subscription)
}

export function storePlusPlanStoredSubscription(subscription: StripeSubscription) {
    localStorage.setItem(PLUS_PLAN_STORAGE_KEY, JSON.stringify(subscription))
}

export function deletePlusPlanStoredSubscription() {
    localStorage.removeItem(PLUS_PLAN_STORAGE_KEY)
}
